module.exports = __webpack_public_path__ + "images/1df7d34b5baed51c984e8cf4f6ac92ac.svg";